import { useSelector } from 'react-redux';
import { useUpdateLanguageCodeMutation } from 'lib/services/languages';
import { selectCurrentLanguage, setLanguage } from 'lib/slices';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { useEffect } from 'react';

export default function useUpdateLanguage() {
    const language = useSelector(selectCurrentLanguage);
    const [updateLanguageCode] = useUpdateLanguageCodeMutation();
    const [storedValue, setLangInStorage] = useLocalStorage(
        'languageCode',
        null,
    );

    useEffect(() => {
        console.log('storedValue', storedValue);
        setLanguage(storedValue || 'eng');
        updateLanguageCode({ languageCode: storedValue || 'eng' }).unwrap();
    }, [storedValue, updateLanguageCode]);

    const handleChange = async (_, value) => {
        setLangInStorage(value);
        setLanguage(value);
        await updateLanguageCode({ languageCode: value }).unwrap();
    };

    return [language, handleChange];
}
